import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';
import { makeStyles, Typography } from './../../../../../assets/theme/default';

const useStyles = makeStyles(theme => ({
  root: {
    fontSize: theme.typography.body2.fontSize,
    lineHeight: 1,
    whiteSpace: 'nowrap'
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    }
  }
}));

const LinkTPPreference = ({ preference }) => {

  const classes  = useStyles();

  return (
    <Typography
      className={ classNames(
        classes.root,
        classes.link
      )}
      component={ NavLink }
      to={ `/api/todopago/checkout/detail/${ preference._id }` }
    >
      { preference.preference_code }
    </Typography>
  )

};

LinkTPPreference.propTypes = {
  preference: PropTypes.object.isRequired
};

export default LinkTPPreference;
